<dsd-input
  dsd-ext-input
  (focusout)="onFocusOut($event.target.value)"
  (paste)="onPaste($event)"
  (keypress)="config.isValidKey($event.charCode) || $event.key === 'Enter'"
  (keydown)="onKeyDown($event)"
  [required]="required"
  [attr.identifier]="identifier"
  [customType]="customType"
  [name]="name"
  [inputmode]="inputmode"
  [inputPrefix]="config.inputPrefix"
  [inputSuffix]="config.inputSuffix"
  [type]="config.type"
  [attr.error]="error"
  [autocomplete]="autocomplete"
  [ngClass]="config.classes"
  [maxDecimalLength]="maxDecimalLength"
  [maxlength]="maxLength"
  [inputWidth]="inputWidth"
  [(ngModel)]="inputValue"
  [value]="inputValue"
  [hideRequiredLabelling]="hideRequiredLabelling"
  [attr.quiet-validate]="quietValidate"
>
  <ng-content select="[label]"></ng-content>
  <ng-content select="[hint]"></ng-content>
  <ng-content select="[error]"></ng-content>
</dsd-input>
